module.exports = __webpack_public_path__ + "img/theme13.eb77be70.png";